import { Navigate, useLocation } from '@tanstack/react-router';
import React, { ReactElement } from 'react';

type DefaultGuardProps = { children: ReactElement | ReactElement[] };

export function DefaultGuard({ children }: DefaultGuardProps): ReactElement {
  const location = useLocation();

  return location.pathname === '/' ? (
    <Navigate to={'/forecast'} search={{ sessionId: undefined }} />
  ) : (
    <>{children}</>
  );
}
